import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, TextField, Container, Typography, Box, Alert } from "@mui/material";
import axios from "axios";

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState("");
    const [passConfirm, setPassConfirm] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const [charLen, setCharLen] = useState(false);
    const [charCombo, setCharCombo] = useState(false);
    const [passMatch, setPassMatch] = useState(false);
    const [canSubmit, setCanSubmit] = useState(false);

    useEffect(() => {
        if (newPassword.length >= 8) {
          setCharLen(true);
        } else {setCharLen(false);}
    
        if (/\d/.test(newPassword) && /[a-zA-Z]/.test(newPassword)) {
          setCharCombo(true);
        } else {setCharCombo(false);}

        if (newPassword === passConfirm && newPassword !== '') {
          setPassMatch(true);
        } else {setPassMatch(false);}
    
        if(charCombo && charLen && passMatch){setCanSubmit(true);}else{setCanSubmit(false);}
      }, [newPassword, passConfirm, charCombo, charLen, passMatch]);
  
    // Get the uid and token from the URL query params
    const params = new URLSearchParams(location.search);
    const uid = params.get('uid');
    const token = params.get('token');
  
    useEffect(() => {
      if (!uid || !token) {
        setError("Invalid or missing reset link.");
      }
    }, [uid, token]);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      // Check if the uid or token is missing
      if (!uid || !token) {
        setError("Invalid or missing reset link.");
        return;
      }
  
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/reset-password/`,
          {
            uid,
            token,
            new_password: newPassword,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          setSuccess(true);
        }
      } catch (err) {
        console.error(err);
        setError("An error occurred while resetting your password.");
      }
    };
  
    return (
      <Box>
        <Box sx={{ textAlign: "center", bgcolor: "primary.dark", p: 4 }}>
          <Typography variant="h2" sx={{fontWeight:650, color:'white', cursor:'pointer'}} onClick={() => navigate('/')}>ExamPortal</Typography>
          <Typography variant="h6" sx={{ color: "white" }}>
            Efficient, Secure, and Painless Pre-Employment Testing
          </Typography>
        </Box>
  
        <Container maxWidth="xs">
          <Box sx={{ mt: 10 }} textAlign="center">
            <Typography variant="h4" gutterBottom>
              New Password
            </Typography>
          </Box>
  
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
  
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Your password has been successfully reset!
            </Alert>
          )}
  
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              margin="normal"
              label="New Password"
              type="password"
              variant="outlined"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Confirm Password"
              type="password"
              variant="outlined"
              value={passConfirm}
              onChange={(e) => setPassConfirm(e.target.value)}
            />
            <Typography sx={charLen ? ({color:'green'}) : ({color:'grey'})}>Password must be at least 8 characters</Typography>
            <Typography sx={charCombo ? ({color:'green'}) : ({color:'grey'})}>Password must contain at least 1 digit and 1 letter</Typography>
            <Typography sx={passMatch ? ({color:'green'}) : ({color:'grey'})}>Passwords must match</Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              disabled={canSubmit !== true}
            >
              Reset Password
            </Button>
          </form>
        </Container>
      </Box>
    );
  };
  
  export default ResetPassword;